import type { IconData } from '@stacksjs/iconify-core'

export const travelAccessibility: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 4a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 4v5h2l4 7h-4l-2.153-3.768A5.002 5.002 0 0 1 0 11a5 5 0 0 1 5.17-4.997A3 3 0 0 1 8 4zm-7 7a2 2 0 1 1 4 0a2 2 0 0 1-4 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelAccessibility
